import { useEffect } from 'react';
import { useReturnToAddAssessment } from '../../../viewModels/useAssessmentsViewModel';

/**
 * PRD-1703: Add assessment sends the user to Settings (`requestedTab`, and
 * `addScenarioOnOpen` to open Add scenario), and the page offers the way back.
 * The request is cleared once met (by Scenarios, once Add scenario is open),
 * so a reload or a revisit doesn't repeat it.
 */
export function useSettingsRequest({ tabs, setActiveTab, requestedTab, addScenarioOnOpen, onRequestHandled, assessmentsModel, onReturnToAddAssessment }) {
  const requestedTabShown = tabs.some((tab) => tab.id === requestedTab);
  useEffect(() => {
    if (!requestedTabShown) return;
    setActiveTab(requestedTab);
    if (!addScenarioOnOpen) onRequestHandled?.();
  }, [requestedTab, requestedTabShown, setActiveTab, addScenarioOnOpen, onRequestHandled]);
  const returnToAdd = useReturnToAddAssessment(assessmentsModel);
  const backToAddAssessment = () => {
    returnToAdd.clear();
    onReturnToAddAssessment?.();
  };
  return { returnToAdd: returnToAdd.returnToAdd, backToAddAssessment };
}
